import { render } from "./SectionSix.vue?vue&type=template&id=4a11aae9&scoped=true"
const script = {}

import "./SectionSix.vue?vue&type=style&index=0&id=4a11aae9&lang=css&scoped=true"

import exportComponent from "/Users/konradfigura/Developer/first-master/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a11aae9"]])

export default __exports__